import { render, staticRenderFns } from "./MyLieferzeiten.vue?vue&type=template&id=88dc90f4&scoped=true"
import script from "./MyLieferzeiten.vue?vue&type=script&lang=js"
export * from "./MyLieferzeiten.vue?vue&type=script&lang=js"
import style0 from "./MyLieferzeiten.vue?vue&type=style&index=0&id=88dc90f4&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_qfdn4gbztslujeagaknuyibsmy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "88dc90f4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Projekte\\Tipsiolive\\tipsiapp\\node_modules\\.pnpm\\vue-hot-reload-api@2.3.4\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88dc90f4')) {
      api.createRecord('88dc90f4', component.options)
    } else {
      api.reload('88dc90f4', component.options)
    }
    module.hot.accept("./MyLieferzeiten.vue?vue&type=template&id=88dc90f4&scoped=true", function () {
      api.rerender('88dc90f4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/MyLieferzeiten.vue"
export default component.exports